import { render, staticRenderFns } from "./basicTabUICustom.vue?vue&type=template&id=48e9f14b&scoped=true&"
import script from "./basicTabUICustom.vue?vue&type=script&lang=js&"
export * from "./basicTabUICustom.vue?vue&type=script&lang=js&"
import style0 from "./basicTabUICustom.vue?vue&type=style&index=0&id=48e9f14b&scoped=true&lang=scss&"
import style1 from "./basicTabUICustom.vue?vue&type=style&index=1&id=48e9f14b&scoped=true&lang=scss&"
import style2 from "./basicTabUICustom.vue?vue&type=style&index=2&id=48e9f14b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e9f14b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48e9f14b')) {
      api.createRecord('48e9f14b', component.options)
    } else {
      api.reload('48e9f14b', component.options)
    }
    module.hot.accept("./basicTabUICustom.vue?vue&type=template&id=48e9f14b&scoped=true&", function () {
      api.rerender('48e9f14b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaImport/components/SiBooking/tabs/basicTabUICustom.vue"
export default component.exports